export default __webpack_public_path__ + "static/media/login.bae00390.gif";